module.exports = __webpack_public_path__ + "static/media/image-courses-suscription.89435e98.png";